var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useField } from 'react-final-form';
import { RadioField } from '@/components/functional/Form/RadioField/RadioField';
import { Text } from '@/components/ui/Typography/Body/Text';
import { draftCheck, validatePaymentOptions, } from '@/utils/validate/resources/rfp/professional/rfpProOffer';
/**
 * コンサルタント案件提案提出 支払い方法選択ラジオボタン
 * @param props
 * @returns
 */
export const RfpProOfferPaymentOptionRadio = (props) => {
    const { className = '', disabled = false, label, name, value } = props, radioFieldProps = __rest(props, ["className", "disabled", "label", "name", "value"]);
    const id = `${name}_${value}`;
    // Field
    const { input: { value: selectedValue }, } = useField(name, {
        subscription: { value: true },
    });
    const checked = selectedValue === value;
    return (_jsx("label", Object.assign({ className: clsx('flex items-center justify-center', 'border border-solid rounded-md', 'w-full h-[60px] px-16', disabled ? 'bg-gray-300' : 'bg-gray-50', !disabled && checked ? 'border-navy-100' : 'border-gray-300', !disabled && 'cursor-pointer', className), htmlFor: id }, { children: _jsxs("div", Object.assign({ className: clsx('flex flex-row items-center gap-x-4') }, { children: [!disabled && (_jsx(RadioField, Object.assign({}, radioFieldProps, { id: id, isNumberValue: true, name: name, validate: draftCheck(validatePaymentOptions), value: value }))), _jsxs(Text, Object.assign({ className: clsx('flex flex-col', {
                        'text-center': disabled,
                        'text-primary': checked && !disabled,
                        'text-textGray': !checked,
                    }), color: 'none', isBold: checked, size: 'md' }, { children: [_jsx("span", { children: label }), disabled && (_jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'sm', tagName: 'span' }, { children: "\u4ECA\u56DE\u306F\u9078\u629E\u3067\u304D\u307E\u305B\u3093" })))] }))] })) })));
};
